import { render, staticRenderFns } from "./BlocksList.vue?vue&type=template&id=00e40acf&scoped=true"
import script from "./BlocksList.vue?vue&type=script&lang=ts"
export * from "./BlocksList.vue?vue&type=script&lang=ts"
import style0 from "./BlocksList.vue?vue&type=style&index=0&id=00e40acf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e40acf",
  null
  
)

export default component.exports